import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { VideoPlaylist } from '@hsi/video-playlist';

@Injectable({
  providedIn: 'root'
})
export class AppSharedService {
  title = new BehaviorSubject<string>('');
  icon = new BehaviorSubject<string>('');
  tennant = localStorage.getItem('company') || 'ashi';
  playlistStore = new BehaviorSubject<VideoPlaylist.Core.Interfaces.Playlist[]>([]);
  controllerStore = new BehaviorSubject<VideoPlaylist.Core.Services.PlaylistController[]>([]);

  constructor(
    private router: Router
    // Inject authenticationService here if available
  ) {}

  setTitle(newTitle: string) {
    // Defer emission to avoid changing parent bindings during the current change-detection pass.
    Promise.resolve().then(() => this.title.next(newTitle));
  }

  setIcon(newIcon: string) {
    // Defer emission to avoid changing parent bindings during the current change-detection pass.
    Promise.resolve().then(() => this.icon.next(newIcon));
  }

  async logout(authenticationService: any) {
    await authenticationService.logOut();
    this.router.navigate(['/', this.tennant, 'login']);
    this.playlistStore.next([]);
    this.controllerStore.next([]);
  }
}